module.exports = __webpack_public_path__ + "static/media/search-personalization-add-to-cart-rate.f2980ead.png";